import { render, staticRenderFns } from "./CouncilsAutoComplete.vue?vue&type=template&id=0d561019&scoped=true&"
import script from "./CouncilsAutoComplete.vue?vue&type=script&lang=js&"
export * from "./CouncilsAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d561019",
  null
  
)

export default component.exports